exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".staff-group{padding-left:1em;padding-top:1em}.staff-group .basic-user-card{padding-left:0}", ""]);

// exports
